import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
import {
  labelStyle,
  tooltip,
  stroke,
  lineXaxis,
  DownloadButton,
  markers,
  responsiveFun,
  getColours,
} from '../../options';
import dict from '../../../dictionary';
import trans from '../../../translations.json';
// import TestData from '../../MohTestingMetrics.json';
import ReducedData from '../../../reducedData.json';
import FuzySearch from '../../fuzySearch/fuzySearch';
import '../../buttonGroup/buttonGroup.scss';
import SearchResultsDropdown from '../../search/searchResultDropdown';
import StackedTable from './testsByPHUDaily-Table';
import { ButtonGroup } from '../../buttonGroup/buttonGroup';

import { round } from '../../utils';

const numResults = 3;

const colors = getColours(['neutral']);
const colors2 = getColours(['percent']);

const viewModes = {
  graph: 'graph',
  table: 'table',
};

var filteredTestData,
  testingVolumes,
  percentPositivity = [];

let phuNum = {};
ReducedData.dataTesting.forEach((item) => {
  if (!Object.keys(phuNum).includes(item.PHU_num)) {
    for (var key in dict.PHUs) {
      if (dict.PHUs[key] === item.PHU_name) {
        phuNum[item.PHU_num] = key;
      }
    }
  }
});
phuNum[2268] = 'Windsor-Essex County Health Unit';

const data = Object.keys(ReducedData.dataPHU).reduce(
  (sum, currPHU) => {
    return sum.concat(
      ReducedData.dataPHU[currPHU].cities.map((city) => {
        return {
          city_name: city,
          phu_name: ReducedData.dataPHU[currPHU][dict.Reporting_PHU],
        };
      }),
    );
  },
  [],
);

class TestsByPhuDailyGraph extends Component {
  state = {
    ready: false,
    keys: Object.keys(ReducedData.dataPHU),
    selection: null,
    selectionColors: colors,
    selectedViewMode: viewModes.graph,
    selectedViewMode2: viewModes.graph,
    series: [],
    secondSeries: [],
    options: {},
    secondOptions: {},
    searchQuery: '',
    searchQueryTime: +Date.now(),
    searchResults: [],
    highlighted: [],
    chartRef: React.createRef(null),
  };

  componentDidMount() {
    this.setData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.selection !== prevState.selection ||
      this.props.selectedTab !== prevProps.selectedTab
    ) {
      this.setData();
    }
  }

  /**
   * Sets search data state after Fuze returns a new search
   */
  searchResultsCallback = (e, results) => {
    this.setState({
      searchQuery: e,
      highlighted: [],
      searchResults: results ? results.slice(0, numResults) : [],
    });
  };

  /**
   * Highlights a specified PHU pill
   */
  onClickSearchResult = (phu_name) => {
    this.setState({
      highlighted: [phu_name],
      searchResults: [],
      searchQuery: phu_name,
      searchQueryTime: +Date.now(),
    });
    this.toggleSelectionOfPHU(phu_name);
  };

  hideDropdown = () => {
    this.setState({ searchResults: [] });
  };

  clearHighlight = (name) => {
    if (this.state.highlighted.includes(name))
      this.setState({
        highlighted: [],
      });
  };

  toggleSelectionOfPHU = (name) => {
    this.setState({
      selection: name,
    });
  };

  setSearchResults = () => {
    setTimeout(
      () =>
        this.setState({
          searchResults: [],
        }),
      200,
    );
  };

  onTabChange = (tabName) => {
    this.setState({
      selectedTab: tabName,
    });
  };

  onViewModeChange = (viewMode) => {
    this.setState({
      selectedViewMode: viewMode,
    });
  };
  onViewModeChange2 = (viewMode) => {
    this.setState({
      selectedViewMode2: viewMode,
    });
  };

  prepData = () => {
    let name = this.state.selection;
    if (name !== null) {
      filteredTestData = { name: name, data: [] };
      var TestData = Object.values(ReducedData.dataTesting);
      let test = TestData.filter(
        (item) => phuNum[item.PHU_num] === name,
      );
      filteredTestData = test
        .map((item, z) => {
          return [
            item[dict.DATE],
            parseFloat(item[dict.testingAvg].replace(/,/g, '')),
            (item[dict.percentPositiveAvg] * 100).toFixed(1),
          ];
        })
        .filter((item) => item);
      filteredTestData = filteredTestData
        .sort((a, b) => new Date(b[0]) - new Date(a[0]))
        .reverse();
      testingVolumes = filteredTestData.map((item, idx) => {
        let value = item ? item[1] : 0;
        return [item[0], value];
      });

      percentPositivity = filteredTestData.map((item, idx) => {
        let value = item ? item[2] : 0;

        return [item[0], value];
      });
    } else {
      testingVolumes = [];
      percentPositivity = [];
    }
  };

  setData = () => {
    this.prepData();
    var series = [
      {
        name: trans.testing.totalTesting[this.props.lang],
        data: testingVolumes,
        type: 'bar',
      },
    ];
    var series2 = [
      {
        name: trans.testing.titleC[this.props.lang],
        data: percentPositivity,
        type: 'line',
      },
    ];

    this.setState({
      series: [...series],
      secondSeries: [...series2],
      options: {
        colors: colors,
        markers: markers,
        stroke: stroke,
        legend: {
          show: false,
        },
        tooltip: tooltip,
        chart: {
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false,
            },
            dynamicAnimation: {
              enabled: false,
            },
          },
          type: 'line',
          toolbar: {
            show: true,
            tools: {
              download: DownloadButton(
                this.props.lang,
                this.props.chartTitle,
              ),
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
          zoom: { enabled: true },
        },
        noData: {
          text: trans.viewModes.noDataPHU[this.props.lang],
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: -40,
          style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: undefined,
            border: '1px solid black',
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          title: {
            text: trans.testing.yaxis[this.props.lang],
          },
          decimalsInFloat: 0,
          labels: {
            style: { ...labelStyle },
            formatter: (value) =>
              this.props.lang === 'fr'
                ? value.toLocaleString()
                : value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
          },
        },
        xaxis: { ...lineXaxis(this.state.selection !== null) },
        responsive: responsiveFun().map((item) => {
          if (item.breakpoint === 640) {
            item.options.noData = {
              text: [
                trans.viewModes.noDataPHU1[this.props.lang],
                trans.viewModes.noDataPHU2[this.props.lang],
              ],
              align: 'center',
              verticalAlign: 'middle',
              offsetX: 0,
              offsetY: -40,
              style: {
                color: undefined,
                fontSize: '14px',
                fontFamily: undefined,
                border: '1px solid black',
              },
            };
          }
          item.options.xaxis = {
            ...lineXaxis(this.state.selection !== null),
          };
          item.options.yaxis.title.text =
            trans.testing.yaxis[this.props.lang];
          return item;
        }),
      },
      secondOptions: {
        colors: colors2,
        markers: markers,
        stroke: stroke,
        legend: {
          show: false,
        },
        tooltip: tooltip,
        chart: {
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false,
            },
            dynamicAnimation: {
              enabled: false,
            },
          },
          type: 'line',
          toolbar: {
            show: true,
            tools: {
              download: DownloadButton(
                this.props.lang,
                this.props.chartTitle,
              ),
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
          zoom: { enabled: true },
        },
        noData: {
          text: trans.viewModes.noDataPHU[this.props.lang],
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: -40,
          style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: undefined,
            border: '1px solid black',
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          title: {
            text: trans.testing.yaxisPerc[this.props.lang],
          },
          labels: {
            style: { ...labelStyle },
            formatter: (value) =>
              this.props.lang === 'fr'
                ? round(value, 1).toLocaleString() + '%'
                : round(value, 1).toString() + '%',
          },
        },
        xaxis: { ...lineXaxis(this.state.selection !== null) },
        responsive: responsiveFun().map((item) => {
          if (item.breakpoint === 640) {
            item.options.noData = {
              text: [
                trans.viewModes.noDataPHU1[this.props.lang],
                trans.viewModes.noDataPHU2[this.props.lang],
              ],
              align: 'center',
              verticalAlign: 'middle',
              offsetX: 0,
              offsetY: -40,
              style: {
                color: undefined,
                fontSize: '14px',
                fontFamily: undefined,
                border: '1px solid black',
              },
            };
          }
          item.options.xaxis = {
            ...lineXaxis(this.state.selection !== null),
          };
          item.options.yaxis.title.text =
            trans.testing.yaxisPerc[this.props.lang];
          item.options.yaxis.labels.formatter = (value) =>
            this.props.lang === 'fr'
              ? round(value, 1).toLocaleString() + '%'
              : round(value, 1).toString() + '%';
          return item;
        }),
      },
      ready: true,
    });
  };

  render() {
    const searchOpts = {
      includeMatches: true,
      keys: ['city_name', 'phu_name'],
    };

    const GetRightView = () => {
      switch (this.state.selectedViewMode) {
        case viewModes.graph:
          return (
            <>
              {/* <LegandCheckbox
                series={this.state.series}
                colours={colors}
                toggle={this.toggle}
              /> */}

              <ReactApexChart
                ref={this.state.chartRef}
                options={this.state.options}
                series={this.state.series}
                height={400}
                aria-hidden="true"
              />
              <p
                dangerouslySetInnerHTML={{
                  __html:
                    trans.general.dataSourceOLIS[this.props.lang],
                }}
              ></p>
            </>
          );
        case viewModes.table:
          return (
            <StackedTable
              lang={this.props.lang}
              selected={this.state.selection}
              graphType="testing-volumes"
            />
          );
        default:
          break;
      }
    };
    const GetRightView2 = () => {
      switch (this.state.selectedViewMode2) {
        case viewModes.graph:
          return (
            <>
              <ReactApexChart
                ref={this.state.chartRef}
                options={this.state.secondOptions}
                series={this.state.secondSeries}
                height={400}
                aria-hidden="true"
              />
              <p
                dangerouslySetInnerHTML={{
                  __html:
                    trans.general.dataSourceOLIS[this.props.lang],
                }}
              ></p>
            </>
          );
        case viewModes.table:
          return (
            <StackedTable
              lang={this.props.lang}
              selected={this.state.selection}
            />
          );
        default:
          break;
      }
    };

    return (
      <div id="">
        <div
          id="compare-chart-"
          className="chart   ontario-margin-bottom-32-!"
        >
          {this.state.ready && (
            <>
              <div
                id="fuzzySearch"
                className="ontario-row ontario-margin-top-16-! ontario-margin-bottom-32-!"
              >
                <div className="ontario-columns ontario-small-12 ontario-medium-4">
                  <div className="ontario-columns">
                    <div className="ontario-row">
                      <div className="ontario-label" >{trans.phu.search[this.props.lang]}</div>
                      <FuzySearch
                        onBlur={this.setSearchResults}
                        searchResultsCallback={
                          this.searchResultsCallback
                        }
                        data={data}
                        minSearchLength={3}
                        searchQuery={this.state.searchQuery}
                        searchQueryTime={this.state.searchQueryTime}
                        searchSettings={searchOpts}
                        searchLabel={
                          trans.heatmap.city[this.props.lang]
                        }
                      />
                      <SearchResultsDropdown
                        results={this.state.searchResults}
                        handleOnClick={this.onClickSearchResult}
                        hideDropdown={this.hideDropdown}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="ontario-row">
                <div className="ontario-column ontario-small-12 ontario-medium-6 ontario-large-6">
                  <h4>
                    {trans.testing.totalTesting[this.props.lang]}
                  </h4>
                  <p>
                    <a href="/data/covid-19-case-data-glossary">
                      {
                        trans.testing.byPHUTestsDailyLink[
                          this.props.lang
                        ]
                      }
                    </a>{' '}
                    {trans.testing.byPHUTestsDaily[this.props.lang]}
                  </p>
                  <ButtonGroup
                    selected={this.state.selectedViewMode}
                    viewModes={viewModes}
                    lang={this.props.lang}
                    handleOnClick={this.onViewModeChange}
                  />
                  <GetRightView />
                </div>
                <div className="ontario-column ontario-small-12 ontario-medium-6 ontario-large-6">
                  <h4>{trans.testing.titleC[this.props.lang]}</h4>
                  <p>
                    <a href="/data/covid-19-case-data-glossary">
                      {
                        trans.testing.byPHUPercentDailyLink[
                          this.props.lang
                        ]
                      }
                    </a>{' '}
                    {trans.testing.byPHUPercentDaily[this.props.lang]}
                  </p>
                  <ButtonGroup
                    selected={this.state.selectedViewMode2}
                    viewModes={viewModes}
                    lang={this.props.lang}
                    handleOnClick={this.onViewModeChange2}
                  />
                  <GetRightView2 />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}
export default TestsByPhuDailyGraph;
